import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";

const LINKS = [
  { label: "Kaupapa", href: "#kaupapa", testid: "nav-link-kaupapa" },
  { label: "What We Do", href: "#what-we-do", testid: "nav-link-what-we-do" },
  { label: "The Plan", href: "#roadmap", testid: "nav-link-roadmap" },
];

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#FBF9F4]/85 backdrop-blur-xl border-b border-[#1E3A2B]/10"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 h-[72px] flex items-center justify-between">
        <button
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center gap-3 group"
          data-testid="nav-logo-button"
        >
          <LogoMark
            compact
            className={`transition-colors duration-500 ${scrolled ? "text-[#121512]" : "text-[#FBF9F4]"}`}
          />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollToSection(l.href)}
              data-testid={l.testid}
              className={`font-mono-brand text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 hover:text-[#D4A359] ${
                scrolled ? "text-[#2C332E]" : "text-[#FBF9F4]/85"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection("#contact")}
            data-testid="nav-cta-funders-suppliers"
            className={`group flex items-center gap-2 rounded-full px-5 py-2.5 font-mono-brand text-[11px] uppercase tracking-[0.18em] transition-colors duration-300 ${
              scrolled
                ? "bg-[#1E3A2B] text-[#FBF9F4] hover:bg-[#2C4A38]"
                : "bg-[#FBF9F4] text-[#121512] hover:bg-[#D4A359] hover:text-[#121512]"
            }`}
          >
            Funders &amp; Suppliers
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </nav>

        <button
          onClick={() => scrollToSection("#contact")}
          data-testid="nav-cta-mobile"
          className={`md:hidden rounded-full px-4 py-2 font-mono-brand text-[10px] uppercase tracking-[0.18em] transition-colors duration-300 ${
            scrolled ? "bg-[#1E3A2B] text-[#FBF9F4]" : "bg-[#FBF9F4] text-[#121512]"
          }`}
        >
          Contact
        </button>
      </div>
    </motion.header>
  );
};
